import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  flowService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'userModel',
    'groupModel',
    'ETaskTypes',
    'workflowModel',
    'taskModel',
    'executionModel',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      User,
      Group,
      ETaskTypes,
      Workflow,
      Task,
      Execution
    ) {
      'use strict';

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        if (status === 400 && err !== undefined) {
          var text = '';
          Object.keys(err).forEach(function (k) {
            if (Array.isArray(err[k])) {
              if (text !== '') {
                text += '<br />';
              }
              err[k].forEach(function (e) {
                text += e;
              });
            }
          });
          if (text === '') {
            text = $filter('translate')('VERIFY FIELD ERRORS');
          }
          return {
            title: $filter('translate')('ERROR'),
            text: text,
            modelState: err,
          };
        }

        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SAVE WORKFLOW'),
        };
      }

      function listModels() {
        var deferred = $q.defer();

        var url = 'workflows';

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new Workflow(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function listExecutions() {
        var deferred = $q.defer();

        var url = 'workflows/executions';

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new Execution(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function listExecutionsMore(id, count) {
        var deferred = $q.defer();

        var url = `workflows/executionsmore/${id}/${count}`;

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new Execution(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function listTasks() {
        var deferred = $q.defer();

        var url = 'workflows/tasks';

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new Task(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function listTasksMore(id, count) {
        var deferred = $q.defer();

        var url = `workflows/tasksmore/${id}/${count}`;

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new Task(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function listWorkflows(idFolder, idDocumentType) {
        var deferred = $q.defer();

        $http
          .get(
            `${webApiSettings.apiServiceBaseUri}workflows/${idFolder}/${idDocumentType}`
          )
          .then((result) => {
            var data = result.data;

            data = resolveReferences(data);

            deferred.resolve(data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function loadByGuid(guid, action) {
        var deferred = $q.defer();

        var url = 'workflows/{0}/{1}';
        url = String.format(url, [
          guid,
          action === 'clone' ? 'clone' : 'complete',
        ]);

        $http
          .get(webApiSettings.apiServiceBaseUri + url, {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;

              data = resolveReferences(data);

              deferred.resolve(data);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function listRevisionWorkflows(idRevision, trigger) {
        var deferred = $q.defer();

        var url = 'workflows/revision';

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              url +
              '/' +
              idRevision +
              '/' +
              trigger
          )
          .then(
            function (res) {
              var data = res.data;

              data = resolveReferences(data);
              deferred.resolve(data);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function getUsersAndGroups() {
        var deferred = $q.defer();

        var promiseUsers = $http.get(
          webApiSettings.apiServiceBaseUri + 'users/byCompany'
        );
        var promiseGroups = $http.get(
          webApiSettings.apiServiceBaseUri + 'groups/withUsers'
        );

        $q.all([promiseGroups, promiseUsers]).then(
          function (results) {
            var groups = resolveReferences(results[0]);
            var users = resolveReferences(results[1]);

            var rs = [];
            rs[0] = groups.data;
            rs[1] = users.data;
            deferred.resolve(rs);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function save(workflow) {
        var deferred = $q.defer();

        //ajusta os usuarios e grupos para enviar para a webapi
        for (
          var cont = 0, len = workflow.swimlanes.length;
          cont < len;
          cont++
        ) {
          var grps = [];
          for (
            var g = 0, gLen = workflow.swimlanes[cont].groups.length;
            g < gLen;
            g++
          ) {
            grps.push(new Group(workflow.swimlanes[cont].groups[g]));
          }

          workflow.swimlanes[cont].groups = grps;

          var usrs = [];
          for (
            var u = 0, uLen = workflow.swimlanes[cont].users.length;
            u < uLen;
            u++
          ) {
            usrs.push(new User(workflow.swimlanes[cont].users[u]));
          }

          workflow.swimlanes[cont].users = usrs;

          var elementsWithGroupsUsers = [ETaskTypes.Notification];

          var elements = workflow.swimlanes[cont].elements.filter(
            function (item) {
              return elementsWithGroupsUsers.indexOf(item.type) > -1;
            }
          );

          for (
            var elCont = 0, elLen = elements.length;
            elCont < elLen;
            elCont++
          ) {
            var elGrps = [];
            for (
              var gel = 0, gelLen = elements[elCont].groups.length;
              gel < gelLen;
              gel++
            ) {
              elGrps.push(new Group(elements[elCont].groups[gel]));
            }

            elements[elCont].groups = elGrps;

            var elUsrs = [];
            for (
              var uel = 0, uelLen = elements[elCont].users.length;
              uel < uelLen;
              uel++
            ) {
              elUsrs.push(new User(elements[elCont].users[uel]));
            }

            elements[elCont].users = elUsrs;
          }
        }

        if (workflow.id) {
          $http
            .put(webApiSettings.apiServiceBaseUri + 'workflows/', workflow)
            .then(
              function () {
                deferred.resolve();
              },
              function (err) {
                deferred.reject(handleError(err.data, err.status));
              }
            );
        } else {
          $http
            .post(webApiSettings.apiServiceBaseUri + 'workflows/', workflow)
            .then(
              function () {
                deferred.resolve();
              },
              function (err) {
                deferred.reject(handleError(err.data, err.status));
              }
            );
        }

        return deferred.promise;
      }

      function _delete(id) {
        var deferred = $q.defer();

        var url = webApiSettings.apiServiceBaseUri + 'workflows/';

        $http.delete(url + id).then(
          function () {
            deferred.resolve(true);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function run() {
        try {
          var flowFactory = {};
          flowFactory.workflowsEnabled = true;

          flowFactory.getUsersAndGroups = logWrapper(
            getUsersAndGroups,
            runtimeConstant.isDebugServicesInternals
          );
          flowFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          flowFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );
          flowFactory.listModels = logWrapper(
            listModels,
            runtimeConstant.isDebugServicesInternals
          );
          flowFactory.listExecutions = logWrapper(
            listExecutions,
            runtimeConstant.isDebugServicesInternals
          );
          flowFactory.listExecutionsMore = logWrapper(
            listExecutionsMore,
            runtimeConstant.isDebugServicesInternals
          );
          flowFactory.listTasks = logWrapper(
            listTasks,
            runtimeConstant.isDebugServicesInternals
          );
          flowFactory.listTasksMore = logWrapper(
            listTasksMore,
            runtimeConstant.isDebugServicesInternals
          );
          flowFactory.listWorkflows = logWrapper(
            listWorkflows,
            runtimeConstant.isDebugServicesInternals
          );
          flowFactory.listRevisionWorkflows = logWrapper(
            listRevisionWorkflows,
            runtimeConstant.isDebugServicesInternals
          );
          flowFactory.loadByGuid = logWrapper(
            loadByGuid,
            runtimeConstant.isDebugServicesInternals
          );

          return flowFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
